import { Volume2, VolumeX } from "lucide-react";
import { useAudio } from "./AudioContext";

export default function SoundControl() {
  const { isPlaying, play, pause, changeTrack, currentTrack } = useAudio();

  return (
    <div className="fixed bottom-5 right-5 flex items-center gap-2 bg-black/70 p-3 rounded-full text-white z-50">
      <button onClick={isPlaying ? pause : play}>
        {isPlaying ? <Volume2 size={20} /> : <VolumeX size={20} />}
      </button>

      <select
        value={currentTrack}
        onChange={(e) => changeTrack(e.target.value)}
        className="bg-black text-white text-sm outline-none"
      >
        <option value="ottoman">Osmanlı</option>
        <option value="bazaar">Çarşı</option>
        <option value="wind">Açık Alan</option>
        <option value="rain">Yağmur</option>
        <option value="fire">Ateş</option>  
      </select>
    </div>
  );
}
